/**
 * Universal Store — Quick Add to Cart pe carduri produs
 * Buton verde vizibil sub produs, FĂRĂ a deschide drawer-ul
 */
(function() {
  'use strict';

  var SELECTOR_CARD = '.grid__item.grid-product';
  var BTN_CLASS     = 'us-quick-atc';

  var ICON_CART = [
    '<svg class="us-quick-atc__icon" width="18" height="18" viewBox="0 0 24 24" fill="none">',
      '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
      '<line x1="3" y1="6" x2="21" y2="6" stroke="#fff" stroke-width="2" stroke-linecap="round"/>',
      '<path d="M16 10a4 4 0 01-8 0" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
    '</svg>'
  ].join('');

  var ICON_CHECK = [
    '<svg class="us-quick-atc__icon" width="18" height="18" viewBox="0 0 24 24" fill="none">',
      '<circle cx="12" cy="12" r="10" fill="rgba(255,255,255,0.25)"/>',
      '<polyline points="8,12 11,15 16,9" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>',
    '</svg>'
  ].join('');

  var ICON_ERROR = [
    '<svg class="us-quick-atc__icon" width="18" height="18" viewBox="0 0 24 24" fill="none">',
      '<circle cx="12" cy="12" r="10" fill="rgba(255,255,255,0.25)"/>',
      '<line x1="15" y1="9" x2="9" y2="15" stroke="#fff" stroke-width="2.5" stroke-linecap="round"/>',
      '<line x1="9" y1="9" x2="15" y2="15" stroke="#fff" stroke-width="2.5" stroke-linecap="round"/>',
    '</svg>'
  ].join('');

  var ICON_SPIN = '<span class="us-quick-atc__spinner"></span>';

  function buildBtnHTML(state) {
    switch(state) {
      case 'loading': return ICON_SPIN + '<span class="us-quick-atc__text">Se adaugă...</span>';
      case 'done':    return ICON_CHECK + '<span class="us-quick-atc__text">Adăugat în coș!</span>';
      case 'error':   return ICON_ERROR + '<span class="us-quick-atc__text">Eroare, încearcă din nou</span>';
      case 'soldout': return ICON_CART  + '<span class="us-quick-atc__text">Stoc epuizat</span>';
      default:        return ICON_CART  + '<span class="us-quick-atc__text">ADAUGĂ ÎN COȘ</span>';
    }
  }

  function injectButtons() {
    var cards = document.querySelectorAll(SELECTOR_CARD);
    cards.forEach(function(card) {
      if (card.querySelector('.' + BTN_CLASS)) return;

      var productId = card.dataset.productId;
      var soldOut   = card.classList.contains('is-sold-out');
      if (!productId) return;

      var btn = document.createElement('button');
      btn.className = BTN_CLASS + (soldOut ? ' us-quick-atc--soldout' : '');
      btn.type = 'button';
      btn.setAttribute('data-product-id', productId);
      btn.disabled = soldOut;
      btn.innerHTML = buildBtnHTML(soldOut ? 'soldout' : 'default');

      if (!soldOut) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          addToCart(btn, card);
        });
      }

      // Adaugam butonul "Adauga in cos" DEASUPRA butonului "Comanda rapida"
      // (daca acesta exista pe card), pentru a pastra aceeasi ordine ca pe
      // pagina de produs: Adauga in cos -> Comanda rapida (sub el).
      var cardWrapper = card.querySelector('.card') || card;
      var crWrapper = cardWrapper.querySelector('.cr-wrapper');
      if (crWrapper) {
        cardWrapper.insertBefore(btn, crWrapper);
      } else {
        cardWrapper.appendChild(btn);
      }
    });
  }

  function getVariantId(card) {
    var hiddenInput = card.querySelector('.ca-form input[name="id"]');
    if (hiddenInput && hiddenInput.value) return Promise.resolve(hiddenInput.value);

    var caSelect = card.querySelector('.ca-select');
    if (caSelect && caSelect.value) return Promise.resolve(caSelect.value);

    var handle = card.dataset.productHandle;
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) {
        var v = p.variants.find(function(v) { return v.available; });
        return v ? String(v.id) : null;
      });
  }

  function addToCart(btn, card) {
    if (btn.classList.contains('us-quick-atc--loading') ||
        btn.classList.contains('us-quick-atc--done')) return;

    btn.classList.add('us-quick-atc--loading');
    btn.innerHTML = buildBtnHTML('loading');
    btn.disabled = true;

    getVariantId(card).then(function(vid) {
      if (!vid) { showError(btn); return; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(vid), quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data && data.id) {
          showSuccess(btn);
          updateCartCount();
          // NU deschidem drawer-ul — rămâne pe pagina de colecție
        } else {
          showError(btn);
        }
      })
      .catch(function() { showError(btn); });
    }).catch(function() { showError(btn); });
  }

  function showSuccess(btn) {
    btn.classList.remove('us-quick-atc--loading');
    btn.classList.add('us-quick-atc--done');
    btn.innerHTML = buildBtnHTML('done');
    btn.disabled = false;
    setTimeout(function() {
      btn.classList.remove('us-quick-atc--done');
      btn.innerHTML = buildBtnHTML('default');
    }, 2200);
  }

  function showError(btn) {
    btn.classList.remove('us-quick-atc--loading');
    btn.classList.add('us-quick-atc--error');
    btn.innerHTML = buildBtnHTML('error');
    btn.disabled = false;
    setTimeout(function() {
      btn.classList.remove('us-quick-atc--error');
      btn.innerHTML = buildBtnHTML('default');
    }, 2200);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var counters = document.querySelectorAll(
          '.cart-count, .header-cart-count, [data-cart-count], .js-cart-count, ' +
          '.cart__count, .cart-link__bubble, .site-header__cart-count'
        );
        counters.forEach(function(el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) {
            el.classList.add('cart-link__bubble--visible');
          }
        });
      })
      .catch(function() {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectButtons);
  } else {
    injectButtons();
  }

  document.addEventListener('shopify:section:load', injectButtons);

  var gridObs = new MutationObserver(function(mutations) {
    var added = mutations.some(function(m) { return m.addedNodes.length > 0; });
    if (added) setTimeout(injectButtons, 120);
  });
  var mainEl = document.querySelector('main, #mainContent');
  if (mainEl) gridObs.observe(mainEl, { childList: true, subtree: true });

})();
